import { render, staticRenderFns } from "./ListingDetailsFeedBedding.vue?vue&type=template&id=77c1ec7e"
import script from "./ListingDetailsFeedBedding.vue?vue&type=script&lang=js"
export * from "./ListingDetailsFeedBedding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports